import {Inject, Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {AuthenticationService} from '../_services/authentication.service';
import {RedirectPostService} from './RedirectPost.service';
import {TiberEnvironment, TiberEnvironmentProvider} from "../environment";
import {RefreshAppDialogService} from "../_services/refresh-app-dialog.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private readonly authenticationService: AuthenticationService,
        private redirectPostService: RedirectPostService,
        @Inject(TiberEnvironmentProvider) private environment: TiberEnvironment,
        private refreshDialog: RefreshAppDialogService
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(catchError(err => {
                if (err.status === 401 || err.status === 403) {
                    this.authenticationService.logout(false);

                    if (this.environment.config.ltiTool) {
                        this.redirectPostService.handleExceptionRedirect('Authentication Failed');
                    } else {
                        let message = (err.error && (err.error.message || err.error.title))
                            ?? err.statusText
                            ?? 'Your session has expired or you are no longer authorized.';

                        if (message?.toLowerCase() === "ok") message += ` - ${err.status}`;

                        this.refreshDialog.show(message);
                    }
                }

                const error = err.error || err.statusText;
                return throwError(() => new Error(error));
            }));
    }
}
